module.exports = __webpack_public_path__ + "img/statusbar.b013d09.png";